var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"data-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('custom-text-area',{attrs:{"disabled":_vm.disabled,"maxlength":_vm.max,"placeholder":_vm.placeholder},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }